import { useStorage } from "@vueuse/core";

declare global {
  interface Window {
    _ddm?: {
      trigger?: (event: string, data: any) => void;
      [key: string]: any;
    };
  }
}

const DDM_VARIANTS = {
  control: "control",
  variant_a: "variant_A",
  variant_b: "variant_B",
} as const;
type DDMVariant = (typeof DDM_VARIANTS)[keyof typeof DDM_VARIANTS];

export default function useExperiments(key: "50_50" | "33_33_33" = "50_50") {
  const DDM = useStorage("dd_p_session", null);

  const parsedDDM = computed(() => (DDM.value ? JSON.parse(DDM.value) : null));

  const variant = computed<DDMVariant>(() =>
    parsedDDM.value?.experiments?.ddm?.[key]
      ? parsedDDM.value?.experiments?.ddm?.[key]
      : null,
  );

  const isControl = computed(() => {
    if (variant.value?.toLowerCase() === DDM_VARIANTS.control.toLowerCase()) {
      return true;
    }

    return false;
  });

  const isVariantA = computed(() => {
    if (variant.value?.toLowerCase() === DDM_VARIANTS.variant_a.toLowerCase()) {
      return true;
    }

    return false;
  });

  const isVariantB = computed(() => {
    if (variant.value?.toLowerCase() === DDM_VARIANTS.variant_b.toLowerCase()) {
      return true;
    }

    return false;
  });

  /**
   * Tracks the experiment variant using the DDM trigger function.
   * This function checks if the DDM object and trigger method are available,
   * and if so, it sends the experiment name and variant to the DDM service.
   */
  const track = () => {
    window._ddm = window._ddm || {};

    if (typeof window._ddm?.trigger === "function" && variant.value) {
      window._ddm.trigger("ddm_experiment", {
        experiment: {
          name: "cancelation policy",
          variant: unref(variant),
        },
      });
    }
  };

  return {
    // computed
    isControl,
    isVariantA,
    isVariantB,
    // methods
    track,
  };
}
